'use client';

import { useSearchPanel } from './use-search-panel';
import { SearchPanel } from './search-panel';
import type { ResolvedNavigationSection } from '@/src/lib/navigation';

export function SearchPanelMonitor({ sections }: { sections: readonly ResolvedNavigationSection[] }) {
  const { isOpen, close } = useSearchPanel();
  return isOpen ? <SearchPanel isOpen onClose={close} sections={sections} /> : null;
}
